import { NestedTreeControl } from '@angular/cdk/tree';
import { Component, Input, OnInit } from '@angular/core';
import { AbstractControl, FormArray, FormControl, FormGroup, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { MatIconRegistry } from '@angular/material/icon';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatTreeNestedDataSource } from '@angular/material/tree';
import { DomSanitizer } from '@angular/platform-browser';
import { ApiHttpService } from 'src/app/services/api-http.service';
import { DataService } from 'src/app/services/data.service';
import { debugForm, setRequired } from 'src/app/shared/utils';

@Component({
  selector: 'app-firma-sottoscrizione',
  templateUrl: './firma-sottoscrizione.component.html',
  styleUrls: ['./firma-sottoscrizione.component.scss']
})
export class FirmaSottoscrizioneComponent implements OnInit {

  @Input() datiPagamento!: FormGroup;
  @Input() disableFirmaVolture!: boolean;

  setRequired = setRequired;

  // public get disableFirmaVolture() : boolean {
  //   console.log(this._disableFirmaVolture);
  //   return this._disableFirmaVolture;
  // }
  // public set disableFirmaVolture(v : boolean) {
  //   console.log(v);
  //   this._disableFirmaVolture = v;
  // }

  treeControl = new NestedTreeControl<treeNode>(node => node.children);
  dataSource = new MatTreeNestedDataSource<treeNode>();
  treeControlWish = new NestedTreeControl<treeNode>(node => node.children);
  dataSourceWish = new MatTreeNestedDataSource<treeNode>();

  premiTree: treeNode[] = []

  premiWishTree: treeNode[] = []

  sedi = [
    { label: 'Altro', value: -1 }
  ]

  datiFirmaForm = new FormGroup({
    mondadori: new FormControl(),
    wishlist: new FormControl(),
    premi: new FormControl(null, [premioValidator(this)]),
    wishlistG: new FormControl(),
    premiG: new FormControl(),
    modoConsegnaPremio: new FormControl(),
    codicePromo: new FormControl('', [convenzioneValidator(this)]),
    sconti: new FormGroup({}),
    energiaVerde: new FormControl(true),
    ripensamento: new FormControl(),
    modalitaFirma: new FormControl('2', [Validators.required]),
    datiFirmaDigitale: new FormGroup({
      email: new FormControl('', [Validators.required, Validators.email, Validators.pattern("^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$")]),
      // telefono: new FormControl('', [Validators.required, Validators.minLength(10), Validators.pattern(/^[0-9]+$/)]),
      telefono: new FormGroup({
        prefisso: new FormControl('0039'),
        numero: new FormControl('', [Validators.required, Validators.minLength(10), Validators.pattern(/^[0-9]+$/)]),
      }),
    }),
    sedeFirma: new FormControl(0),
    indirizzoSedeFirma: new FormGroup({
      toponimo: new FormControl('', [Validators.required]),
      indirizzo: new FormControl('', [Validators.required]),
      civico: new FormControl('', [Validators.required]),
      comune: new FormControl('', [Validators.required]),
      cap: new FormControl('', [Validators.required]),
      provincia: new FormControl('', [Validators.required])
    })
  })

  get indirizzoSedeFirma() {
    return this.datiFirmaForm.get('indirizzoSedeFirma') as FormGroup;
  }

  // premioConfermato: boolean = false;
  // premioConfermatoG: boolean = false;
  premioConfermato: boolean = true;
  premioConfermatoG: boolean = true;
  disableInvioMail = false;

  sconti: any[] = [];

  constructor(
    private matIconRegistry: MatIconRegistry,
    private domSanitizer: DomSanitizer,
    public dataService: DataService,
    private httpService: ApiHttpService,
    private snackBar: MatSnackBar
  ) {
    this.dataSource.data = this.premiTree.sort((a: any, b: any) => {
      if (a.nome < b.nome) {
        return -1;
      }
      else if (a.nome > b.nome) {
        return 1;
      }
      else {
        return 0;
      }
    });
    this.dataSourceWish.data = this.premiWishTree.sort((a: any, b: any) => {
      if (a.nome < b.nome) { return -1; }
      else if (a.nome > b.nome) { return 1; }
      else { return 0; }
    });

    this.dataSource.data.map(element => {
      if (element.children!.length > 0) {
        element.children!.sort((a: any, b: any) => {
          if (a.nome < b.nome) { return -1; }
          else if (a.nome > b.nome) { return 1; }
          else { return 0; }
        })
      }
    })

    this.dataSourceWish.data.map(element => {
      if (element.children!.length > 0) {
        element.children!.sort((a: any, b: any) => {
          if (a.nome < b.nome) { return -1; }
          else if (a.nome > b.nome) { return 1; }
          else { return 0; }
        })
      }
    })

    // this.matIconRegistry.addSvgIcon(
    //   `amazon`,
    //   this.domSanitizer.bypassSecurityTrustResourceUrl(`../assets/imgs/amazon_logo.svg`)
    // );
    // this.matIconRegistry.addSvgIcon(
    //   `mondadori`,
    //   this.domSanitizer.bypassSecurityTrustResourceUrl(`../assets/imgs/mondadori.svg`)
    // );
  }

  hasChild = (_: number, node: treeNode) => !!node.children && node.children.length > 0;

  ngOnInit(): void {

    this.datiFirmaForm.get('energiaVerde')?.disable();

    // this.datiFirmaForm.valueChanges.subscribe(value => {
    //   debugForm(this.datiFirmaForm.controls);
    // });

    this.datiPagamento?.get('modalitaSpedizione')?.valueChanges.subscribe(value => {
      if (value == '0') {
        // this.datiFirmaForm.get('modalitaFirma')?.patchValue('0', { emitEvent: false });
        // this.datiFirmaForm.get('modoConsegnaPremio')?.patchValue('0', { emitEvent: false });
        this.disableInvioMail = false;
      } else {
        // this.datiFirmaForm.get('modalitaFirma')?.patchValue('1', { emitEvent: false });
        // this.datiFirmaForm.get('modoConsegnaPremio')?.patchValue('1', { emitEvent: false });
        this.disableInvioMail = true;
      }
    })

    // if (this.dataService.prodotto?.tipo_utenza == 'DOM' && !['TUTELA', 'VULNERABILI', 'PLACET'].includes(this.dataService.prodotto!.natura)) {
    //   this.datiFirmaForm.get('modoConsegnaPremio')?.setValidators([Validators.required]);
    // }

    // this.datiFirmaForm.get('modalitaFirma')?.valueChanges.subscribe(value => {
    //   if (value == '0') {
    //     this.datiFirmaForm.get('datiFirmaDigitale')?.get('email')?.setValidators([Validators.required, Validators.email, Validators.pattern("^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$")]);
    //     this.datiFirmaForm.get('datiFirmaDigitale')?.get('telefono')?.get('prefisso')?.setValidators([Validators.required, Validators.minLength(4), Validators.maxLength(4), Validators.pattern(/^[0-9]+$/)]);
    //     this.datiFirmaForm.get('datiFirmaDigitale')?.get('telefono')?.get('numero')?.setValidators([Validators.required, Validators.minLength(10), Validators.maxLength(10), Validators.pattern(/^[0-9]+$/)]);
    //   } else {
    //     this.datiFirmaForm.get('datiFirmaDigitale')?.get('email')?.clearValidators();
    //     this.datiFirmaForm.get('datiFirmaDigitale')?.get('telefono')?.get('prefisso')?.clearValidators();
    //     this.datiFirmaForm.get('datiFirmaDigitale')?.get('telefono')?.get('numero')?.clearValidators();
    //   }
    //   this.datiFirmaForm.get('datiFirmaDigitale')?.get('email')?.updateValueAndValidity();
    //   this.datiFirmaForm.get('datiFirmaDigitale')?.get('telefono')?.get('prefisso')?.updateValueAndValidity();
    //   this.datiFirmaForm.get('datiFirmaDigitale')?.get('telefono')?.get('numero')?.updateValueAndValidity();
    // })

    this.datiFirmaForm.get('modalitaFirma')?.valueChanges.subscribe(value => {
      this._aggiornaValidatoriFirmaDigitale(value);
    })

    // Applica subito la logica anche al valore iniziale (es. modalitaFirma
    // parte già a '2' e non cambia mai: valueChanges non scatterebbe da solo)
    this._aggiornaValidatoriFirmaDigitale(this.datiFirmaForm.get('modalitaFirma')?.value);

    if (this.dataService.user == 3) {
      this.datiFirmaForm.get('ripensamento')?.patchValue(true);
    }

    this.datiFirmaForm.get('indirizzoSedeFirma')?.disable();
    this.datiFirmaForm.get('sedeFirma')?.valueChanges.subscribe(value => {
      if (value == -1) {
        this.indirizzoSedeFirma.enable();
      } else {
        this.indirizzoSedeFirma.disable();
      }
    })

    // this.httpService.get('convenzioni/get_lista_sconti', {
    //   'fornitura': this.dataService.prodotto?.cod_tipo_fornitura_id
    // }).subscribe((res: any) => {
    //   this.sconti = res;
    //   res.forEach((element: any) => {
    //     this.scontiFormGroup.addControl(
    //       element.key, new FormControl(null)
    //     );
    //   })
    // })

    if (this.dataService.ctr_data) {
      setTimeout(() => {
        let datiFirma = this.dataService.ctr_data.datiFirma;
        delete datiFirma.mailOperatore;
        this.datiFirmaForm.patchValue(datiFirma);
        if (datiFirma.premi != '' && datiFirma.premi != null) {
          this.confermaPremio(true);
        }
        if (datiFirma.premiG != '' && datiFirma.premiG != null) {
          this.confermaPremioG(true);
        }
        if (datiFirma.codicePromo) {
          this.checkConvenzione();
        }
      }, 2000);
    }

  }

  private _aggiornaValidatoriFirmaDigitale(value: string | undefined | null) {
    if (value == '0') {
      this.datiFirmaForm.get('datiFirmaDigitale')?.get('email')?.setValidators([Validators.required, Validators.email, Validators.pattern("^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$")]);
      this.datiFirmaForm.get('datiFirmaDigitale')?.get('telefono')?.get('prefisso')?.setValidators([Validators.required, Validators.minLength(4), Validators.maxLength(4), Validators.pattern(/^[0-9]+$/)]);
      this.datiFirmaForm.get('datiFirmaDigitale')?.get('telefono')?.get('numero')?.setValidators([Validators.required, Validators.minLength(10), Validators.maxLength(10), Validators.pattern(/^[0-9]+$/)]);
    } else {
      this.datiFirmaForm.get('datiFirmaDigitale')?.get('email')?.clearValidators();
      this.datiFirmaForm.get('datiFirmaDigitale')?.get('telefono')?.get('prefisso')?.clearValidators();
      this.datiFirmaForm.get('datiFirmaDigitale')?.get('telefono')?.get('numero')?.clearValidators();
    }
    this.datiFirmaForm.get('datiFirmaDigitale')?.get('email')?.updateValueAndValidity();
    this.datiFirmaForm.get('datiFirmaDigitale')?.get('telefono')?.get('prefisso')?.updateValueAndValidity();
    this.datiFirmaForm.get('datiFirmaDigitale')?.get('telefono')?.get('numero')?.updateValueAndValidity();
  }


  get premi() {
    return this.datiFirmaForm.get('premi') as FormControl;
  }
  get premiG() {
    return this.datiFirmaForm.get('premiG') as FormControl;
  }

  get mailTo() {
    return (this.dataService.datiPagamento?.get('mails') as FormArray)?.at(0)?.value;
  }

  get isScontoSelected() {
    const isAnyScontoSelected = this.scontiFormGroup.value.some((obj: any) => {
      const scontoValue = Object.values(obj)[0];
      return scontoValue !== null && scontoValue !== undefined && scontoValue !== '';
    });

    if (!isAnyScontoSelected) {
      return true;
    }
    return false;
  }

  get scontiFormGroup() {
    return this.datiFirmaForm.get('sconti') as FormGroup;
  }

  setConfermaPremiDisabled() {
    switch (this.premi.value) {
      case '0':
        return !!!this.datiFirmaForm.get('mondadori')?.value;
      case '2':
        return !!!this.datiFirmaForm.get('wishlist')?.value;
      default:
        return false;
    }

  }

  setConfermaPremiDisabledG() {
    switch (this.premiG.value) {
      case '0':
        return !!!this.datiFirmaForm.get('mondadoriG')?.value;
      case '2':
        return !!!this.datiFirmaForm.get('wishlistG')?.value;
      default:
        return false;
    }

  }

  confermaPremio(state: boolean) {
    this.premioConfermato = state;
    if (state) {
      this.datiFirmaForm.get('premi')?.removeValidators(premioValidator(this));
    } else {
      this.datiFirmaForm.get('premi')?.addValidators(premioValidator(this));
    }
    this.datiFirmaForm.get('premi')?.updateValueAndValidity();
  }

  confermaPremioG(state: boolean) {
    this.premioConfermatoG = state;
    if (state) {
      this.datiFirmaForm.get('premiG')?.removeValidators(premioGValidator(this));
    } else {
      this.datiFirmaForm.get('premiG')?.addValidators(premioGValidator(this));
    }
    this.datiFirmaForm.get('premiG')?.updateValueAndValidity();
  }


  downloadPrivacy(value: number) {
    if (value == 0) {
      this.httpService.downloadPdf('Informativa Privacy ASPM ti augura buona lettura.pdf');
    } else if (value == 1) {
      window.open('https://www.aureaenergia.it/?jet_download=520b1128d8de8be295e23c3ad3872d61a5836ef2', '_blank');
      // this.httpService.downloadPdf('Informativa Privacy_ASPM ti regala Amazon.pdf');
    } else if (value == 2 || value == 3) {
      window.open('https://www.aureaenergia.it/?jet_download=124bf281ec616f044e414a698768927a53e3ea93', '_blank');
      // this.httpService.downloadPdf('Informativa Privacy_ASPM da energia alle tue passioni.pdf');
    } else if (value == 4) {
      window.open('https://www.aureaenergia.it/?jet_download=97a2e8d6b5387c29e9debaf775c5db5b751d572a', '_blank');
    }
  }
  downloadRegolamento(value: number) {
    if (value == 0) {
      this.httpService.downloadPdf('Regolamento_ASPM ti augura buona lettura.pdf');
    } else if (value == 1) {
      window.open('https://www.aureaenergia.it/?jet_download=654c1ad9f2338a434c78d92e28772b87547eaa3d', '_blank');
      // this.httpService.downloadPdf('Regolamento_ASPM ti regala Amazon.pdf');
    } else if (value == 2 || value == 3) {
      window.open('https://www.aureaenergia.it/?jet_download=574f3928ef4892f096c221035fe70710f318e12d', '_blank');
      // this.httpService.downloadPdf('Regolamento_ASPM da energia alle tue passioni.pdf');
    } else if (value == 4) {
      window.open('https://www.aureaenergia.it/?jet_download=1a77e99e360ec299de26a30e2d3791c98a7a8a4e', '_blank');
    }

  }


  checkConvenzione() {
    this.httpService.post('convenzioni/check_codice', {
      codice: this.datiFirmaForm.get('codicePromo')?.value,
      vendor: this.dataService.vendor,
      fornitura: this.dataService.prodotto?.cod_tipo_fornitura_id
    }).subscribe((res: any) => {
      if (res.esiste) {
        this.snackBar.open('La convenzione indicata è valida', undefined, { panelClass: ['snack-success'], duration: 3000 });
        this.datiFirmaForm.get('codicePromo')?.disable();
        this.datiFirmaForm.get('codicePromo')?.removeValidators(convenzioneValidator(this));
        if (res.json_valori) {
          this.scontiFormGroup.reset();
          this.scontiFormGroup.patchValue(res.json_valori);
          this.scontiFormGroup.disable();
        }
        // this.sconti = res.sconti;
      } else {
        this.datiFirmaForm.get('codicePromo')?.reset();
        // this.sconti = [];
        this.snackBar.open('La convenzione indicata non è valida o esistente', undefined, { panelClass: ['snack-error'], duration: 3000 });
      }
    })
  }

  updateConvenzione() {
    this.datiFirmaForm.get('codicePromo')?.enable();
    this.scontiFormGroup.enable();
    this.scontiFormGroup.reset();
  }

  resetSconto(array_index: number, key: string) {
    (this.datiFirmaForm.get('sconti') as FormArray).at(array_index).get(key)?.reset();
  }

  setConvenzione(nome: string) {
    this.datiFirmaForm.get('codicePromo')?.patchValue(nome);
    this.checkConvenzione();
  }

}

interface treeNode {
  nome: string;
  id?: number;
  img?: string;
  children?: treeNode[];
}


export function premioValidator(component: FirmaSottoscrizioneComponent): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    if (control.value && !component.premioConfermato) {
      return { unchecked: true };
    }
    return null;
  }
}
export function premioGValidator(component: FirmaSottoscrizioneComponent): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    if (control.value && !component.premioConfermatoG) {
      return { unchecked: true };
    }
    return null;
  }
}
export function convenzioneValidator(component: FirmaSottoscrizioneComponent): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    if (control.value) {
      return { unchecked: true };
    }
    return null;
  }
}

